import React, { FunctionComponent } from 'react';
import type { Employment } from '../../../types/toppage';

const employmentTitleHash = {
  new_grad: '新卒',
  internship: 'インターン',
  part_time: 'アルバイト',
  mid_career: '転職・中途',
  side_job: '副業・業務委託',
  others: 'その他',
} as const;

type Props = {
  employments: Employment[];
};

export const Presentation: FunctionComponent<Props> = ({ employments }) => {
  const getEmploymentName = (name: string) => {
    if (Object.keys(employmentTitleHash).includes(name)) {
      return employmentTitleHash[name as keyof typeof employmentTitleHash];
    }
    return name;
  };

  return (
    <section className="sitetop-recruitment-employment">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          EMPLOYMENT<span className="sitetop-pickup-sub">雇用形態から探す</span>
        </h2>
      </div>
      <div className="sitetop-location-container">
        <nav className="sitetop-occupation-employment">
          {employments.map((employment) => (
            <a
              key={employment.id}
              href={'/' + employment.name}
              className="sitetop-occupation-employment-btn"
              data-event="click"
              data-category="topcontent"
              data-value="from_employments"
            >
              {getEmploymentName(employment.name)}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
};
